(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('acReportLayoutMenu', {
        templateUrl: 'views/components/views/acReportLayoutMenu/acReportLayoutMenu.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'acReportLayoutMenuService', 'ttGridFactory', function ($stateParams, stateService, translateService, modalService, acReportLayoutMenuService, ttGridFactory) {

            // #region VARIABLES & DEFINITIONS
            
            const vm = this;
            let acReportLayoutKeyno = $stateParams.acreportlayout_keyno;

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                gridReady: false,
                menu: {},
                renumbering: false,
                copying: false,
                lockedDelete: false
            };

            vm.grid = new ttGridFactory({
                rememberId: 'w_acreportlayoutmenu_grid',
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            }).setCustomToolbarButtons([{
                name: 'acreportlayoutmenu_new',
                text: 'acreportlayoutmenu_new',
                func: () => {
                    stateService.go('acreportlayoutline', {
                        acreportlayout_keyno: vm.model.menu.acreportlayout_keyno,
                        acreportlayoutline_keyno: '0'
                    });
                },
                icon: 'fa-plus',
                cssClass: 'btn btn-primary im-grid-btn-xs-r',
                translate: true
            }]);
            
            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadMenu() {
                vm.model.menu = (await acReportLayoutMenuService.getAcReportLayoutMenu({ acreportlayout_keyno: acReportLayoutKeyno }))[0];

                return loadGrid();
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region GRID PROCEDURE FUNCTION CALLS

            async function loadGrid() {
                vm.grid.dataTask.loadData = {
                    method: 2805,
                    parameters: vm.model.menu
                };

                vm.model.gridReady = true;

                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
            }

            // #endregion GRID PROCEDURE FUNCTION CALLS

            // #region BUTTON RENUMBER PROCEDURE FUNCTION CALL

            vm.renumberChanges = function () {
                vm.model.renumbering = true;

                acReportLayoutMenuService.renumberGrid(vm.model.menu).then(function (response) {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.renumbering = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.renumbering = false;
                        loadGrid();
                    }
                });
            };

		    // #endregion BUTTON RENUMBER PROCEDURE FUNCTION CALL

            // #region BUTTON COPY PROCEDURE FUNCTION CALL

            vm.copyChanges = function () {
                vm.model.copying = true;

                acReportLayoutMenuService.copyObj(vm.model.menu).then(function (response) {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.copying = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.copying = false;
                        stateService.back();
                    }
                });
            };

		    // #endregion BUTTON COPY PROCEDURE FUNCTION CALL

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.deleteValues = function () {
                vm.model.lockedDelete = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(() => {
                    acReportLayoutMenuService.deleteItem(vm.model.menu).then((response) => {
                        if (response[0] && response[0].errorcode !== '0') {
                        	modalService.show({
                        		type: 'warning',
                        		title: translations.error,
                        		message: response[0].errormessage,
                        		buttons: [{
                        			label: translations.ok,
                        			cssClass: 'btn-warning',
                        			action: (dialogItself) => {
                        				dialogItself.close();
                        				vm.model.lockedDelete = false;
                        			}
                        		}]
                        	});
                        } else {
                        	vm.model.lockedDelete = false;
                        	stateService.back();
                        }
                    }, () => vm.model.lockedDelete = false);
                }, () => vm.model.lockedDelete = false);
            };

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadMenu();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
